import { useXHR } from "@sembark-travel/xhr"
import { useEffect, useMemo } from "react"
import { useAuthUser } from "../Auth"
import { WebSocketsContext } from "./hooks"
import { createClient, isRealtimeEnabled } from "./utils"

/**
 * Connects to the realtime server once the user is authenticated and exposes the
 * client to the tree. Tears the connection down on logout / user change.
 */
export function WebSocketsProvider({
	children,
}: {
	children: React.ReactNode
}) {
	const xhr = useXHR()
	const { user } = useAuthUser()
	const userId = user?.id

	const client = useMemo(
		() => (userId && isRealtimeEnabled() ? createClient(xhr) : null),
		[userId, xhr]
	)

	useEffect(() => {
		if (!client) {
			return
		}
		return () => client.disconnect()
	}, [client])

	return (
		<WebSocketsContext.Provider value={client}>
			{children}
		</WebSocketsContext.Provider>
	)
}
